import { render, staticRenderFns } from "./LocationsModal.vue?vue&type=template&id=b35b7f2c"
import script from "./LocationsModal.vue?vue&type=script&lang=js"
export * from "./LocationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports